/**
 * @fileoverview GET handler for the "/companies/:company_id/developers/current/pref_center_url" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { companiesCompanyIdDevelopersCurrentPrefCenterUrl } from "./constants";
import type { CompaniesCompanyIdDevelopersCurrentPrefCenterUrlResult } from "./types";

export const getCompaniesCompanyIdDevelopersCurrentPrefCenterUrl = reactQueryFetcherAdapter(
  companiesCompanyIdDevelopersCurrentPrefCenterUrl,
  (signal: AbortSignal, companyId: string): Promise<CompaniesCompanyIdDevelopersCurrentPrefCenterUrlResult> => {
    return fetch(
      `/companies/${companyId}/developers/current/pref_center_url`,
      "GET",
      {},
      { signal, mode: "cors" },
      {
        // don't display a modal when this endpoint fails
        propagateFetchRequestError: false,
      }
    );
  }
);
